export default {
  errors: {
    serverDown: "Remote server is down",
    unknownError: "An error occurred on the remote server"
  }
}
